export interface VideoPlaybackConditions {
  isDocumentVisible: boolean
  isSectionVisible: boolean
  prefersReducedMotion: boolean
  saveDataEnabled: boolean
}

export const canPlayBannerVideo = ({
  isDocumentVisible,
  isSectionVisible,
  prefersReducedMotion,
  saveDataEnabled,
}: VideoPlaybackConditions) =>
  isDocumentVisible &&
  isSectionVisible &&
  !prefersReducedMotion &&
  !saveDataEnabled
